import { MdChevronLeft, MdChevronRight } from 'react-icons/md';

function Pagination({ page, pages, total, limit = 10, onChange }) {
  if (pages <= 1) return null;

  const from = total === 0 ? 0 : (page - 1) * limit + 1;
  const to   = Math.min(page * limit, total);

  // Build page number array with ellipsis
  const pageNumbers = Array.from({ length: pages }, (_, i) => i + 1)
    .filter(p => p === 1 || p === pages || Math.abs(p - page) <= 1)
    .reduce((acc, p, idx, arr) => {
      if (idx > 0 && p - arr[idx - 1] > 1) acc.push('...');
      acc.push(p);
      return acc;
    }, []);

  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-gray-100 flex-wrap gap-2">
      <p className="text-sm text-gray-400">
        {total === 0 ? 'No results' : (
          <>Showing <span className="font-medium text-secondary">{from}–{to}</span> of{' '}
          <span className="font-medium text-secondary">{total}</span></>
        )}
      </p>
      <div className="flex items-center gap-1">
        <button
          onClick={() => onChange(page - 1)}
          disabled={page <= 1}
          className="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 text-gray-500 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          <MdChevronLeft className="text-xl" />
        </button>

        {pageNumbers.map((p, i) =>
          p === '...' ? (
            <span key={`e${i}`} className="w-8 h-8 flex items-center justify-center text-gray-400 text-sm">…</span>
          ) : (
            <button
              key={p}
              onClick={() => onChange(p)}
              className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-medium transition-colors
                ${page === p
                  ? 'bg-primary text-white shadow-sm'
                  : 'border border-gray-200 text-gray-500 hover:bg-gray-50'}`}
            >
              {p}
            </button>
          )
        )}

        <button
          onClick={() => onChange(page + 1)}
          disabled={page >= pages}
          className="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 text-gray-500 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          <MdChevronRight className="text-xl" />
        </button>
      </div>
    </div>
  );
}

export default Pagination;
